<template>
  <div class="sign-up pop-up">
    <div class="sign-up__inner">
      <div class="sign-up__content">
        <div class="sign-up__logo-text-box">
          <a class="sign-up__logo" href="/">
            <img
              class="sign-up__logo-img"
              src="@/assets.v2/images/logo-sign-up.svg"
              alt="Shortform"
            />
          </a>
        </div>
      </div>
      <div class="sign-up__form-box">
        <div v-if="view.state === 'form'" class="shortform-sign-up">
          <h2 class="shortform-sign-up__title">Reset Your Password</h2>
          <p>
            Enter a new password for your
            <b>{{ view.email }}</b>
            account below.
          </p>
          <form
            role="form"
            class="shortform-sign-up__form"
            novalidate
            @submit.prevent="submitForm"
          >
            <div class="shortform-sign-up__group">
              <label class="shortform-sign-up__label" for="reset_password"
                >New Password</label
              >
              <InputWithContextMenu
                id="reset_password"
                v-model="view.model.password"
                class="shortform-sign-up__input"
                placeholder=""
                type="password"
                autocomplete="current-password"
                autofocus
                :class="view.validation.stateClass('password')"
              />
              <FormError :errors="view.validation.errors" field="password" />
              <FormError :errors="view.validation.errors" field="reset_token" />
            </div>
            <div class="shortform-sign-up__group">
              <button
                type="submit"
                class="shortform-sign-up__submit button button--theme"
              >
                Set a new password
              </button>
            </div>
          </form>
        </div>
        <div v-if="view.state === 'notoken'" class="shortform-sign-up">
          <p>Please use the link from the email to reset the password.</p>
        </div>
        <div v-if="view.state === 'success'" class="shortform-sign-up">
          <p>
            You've successfully changed your password and we've logged you in!
          </p>
          <p>
            <router-link :to="{ name: 'home' }" style="color: #ffb600"
              ><strong>Go to Shortform</strong></router-link
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'

import { PasswordResetView } from '@/models/auth/models'
import { authCssFix } from '@/helpers/html'

import FormError from '@/components/ui/FormError.vue'
import InputWithContextMenu from '@/app/components/InputWithContextMenu.vue'

const route = useRoute()

const view = ref(new PasswordResetView())

onMounted(async () => {
  const token = route.query.reset_token
  await view.value.initResetToken(token as string)

  authCssFix()
})

async function submitForm(): Promise<void> {
  view.value.submitForm()
}
</script>
